import { Attrs, MinzeElement } from 'minze'

export interface LvcDiscoveryArrowLeftIcon {
  dataColor?: string
  width?: number
  height?: number
}

export class LvcDiscoveryArrowLeftIcon extends MinzeElement {
  attrs: Attrs = [['data-color'], ['width', 47], ['height', 47]]

  html = () => `
  <svg width="45" height="14" viewBox="0 0 45 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.2991 6.56373C16.6021 6.47558 18.7178 6.40946 20.8445 6.31029C26.1888 6.06787 31.5442 5.81442 36.8885 5.56098C38.7949 5.47283 40.7012 5.38467 42.6075 5.31856C43.1144 5.29652 43.6323 5.29652 44.1282 5.40671C44.58 5.50588 44.9436 5.86952 44.8224 6.36539C44.7452 6.67392 44.4918 7.02654 44.2163 7.18081C43.9188 7.35712 43.5111 7.35712 43.1475 7.37916C41.5386 7.48935 39.9298 7.59954 38.31 7.66566C30.6186 8.00725 22.9161 8.32681 15.2247 8.65739C14.9492 8.66841 14.6627 8.75656 14.3872 8.80064C13.9575 9.53893 14.1889 10.2882 14.1448 10.9935C14.1118 11.5004 14.1117 12.0183 14.0016 12.5141C13.8914 13.032 13.098 13.4508 12.6021 13.3075C12.3927 13.2524 12.1724 13.1643 11.9961 13.043C9.20819 11.0926 6.07872 9.83645 2.97129 8.50312C2.37625 8.24968 1.79223 7.90808 1.26331 7.52241C0.701324 7.10368 0.712345 6.21112 1.26331 5.79239C1.67102 5.48385 2.13383 5.25245 2.59663 5.03206C5.40654 3.75383 8.18339 2.44254 10.817 0.822708C11.3018 0.525189 11.8748 0.326842 12.4368 0.194612C13.0759 0.0403422 13.66 0.459072 13.5498 1.14227C13.3955 2.10094 14.1448 2.77311 14.0897 3.67669C14.0346 4.55823 13.9795 5.43977 14.2991 6.56373Z" fill="white"/>
  </svg>
    
  
  `

  css = () => `
    :host {
      width: ${this.width}px;
      height: ${this.height}px;
      display:flex;
      align-items:center;
    }
  `
}
